import meter1 from "../assets/img/woman4.jpeg";
import woman2 from "../assets/img/rachael.png";
import meter2 from "../assets/img/man1.jpg";
import meter3 from "../assets/img/woman1.jpg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"

export const Testimony = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="testimony" id="testimony">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="testimony-bx wow zoomIn">
                        <h2>Testimonies</h2>
                        <p>Hear the testimonies of some of our satisfied clients across the globe.</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme testimony-slider">
                            <div className="item">
                                <img src={woman2} alt="art" />
                                <h6>Dr. Canince</h6>
                                <small>We were very satisfied with the print qulity we recieved from TotleSoft. Prompt and good quality delivery.</small>
                            </div>
                           
                            <div className="item">
                                <img src={meter2} alt="art" />
                                <h6>Pst. Isaac U.</h6>
                                <small>I was so impressed with the quick response. The Graphic Designer that designed our church flyer realy knows what he was doing.</small>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="art" />
                                <h6>Mrs. Onome.</h6>
                                <small>After recieving the first flyers & Flex Banners, I was so impressed with the quality that TotleSoft is now my go to anytime I have a printing need</small>
                            </div>
                            
                            <div className="item">
                                <img src={meter1} alt="art" />
                                <h6>Mary Mark</h6>
                                <small>You guys are good. This Mobile App is beyond my expectation. Thanks.</small>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="art" />
    </section>
  )
}
